<template>
  <div class="catalog-card-list">
    <div v-for="(subItem, index) in items" :key="subItem.id || index" class="catalog-card-item">
      <div class="card-inner">

        <!-- Image -->
        <div class="card-image-wrapper">
          <img :src="subItem.cover_image_link" :alt="subItem.name" class="card-image"
            @click="$emit('view-card', subItem.id)" />
        </div>

        <!-- Content -->
        <div class="card-content">

          <!-- Title -->
          <h5 class="card-title">
            {{ subItem.name }}
          </h5>

          <!-- Actions -->
          <div class="card-actions">

            <!-- Assigned Training -->
            <button v-if="subItem.has_been_assigned" class="btn btn-sm btn-info" type="button"
              @click="$emit('view-card', subItem.id)">
              <i class="uil-play-circle"></i>
              {{ getBottomTitle(subItem.completion_percentage) }}
            </button>

            <!-- NOT Assigned -->
            <template v-else>

              <!-- REGISTER / BUY -->
              <template v-if="filters?.can_register_trainings">

                <!-- FREE REGISTER -->
                <button v-if="subItem.self_registrable_trainings?.length > 0 &&
                  Number(subItem.price) === 0
                  " class="btn btn-sm btn-success" type="button" @click="
    $emit('self-training', {
      id: subItem.id,
      mode: 'register'
    })
    ">
                  <i class="uil-check-circle"></i>
                  {{ $t('general.sign_up') }}
                </button>

                <!-- PAID TRAINING -->
                <template v-else-if="subItem.self_registrable_trainings?.length > 0 &&
                  Number(subItem.price) > 0
                  ">
                  <span class="price-tag">
                    {{ formatPrice(subItem.price, subItem.currency) }}
                  </span>

                  <button class="btn btn-sm btn-success" type="button" @click="
                    $emit('self-training', {
                      id: subItem.id,
                      mode: 'buy'
                    })
                    ">
                    <i class="uil-check-circle"></i>
                    {{ $t('general.buy') }}
                  </button>
                </template>

                <!-- DEMO -->
                <button v-if="isDemoActive(subItem)" class="btn btn-sm btn-warning" type="button" uk-tooltip="
                    title: Bu eğitim demo linkidir.
                    İzlediğiniz ilerleme kaydedilmez.;
                    pos: top-right
                  " @click="$emit('demo', subItem.id)">
                  <i class="uil-eye"></i>
                  Demo
                </button>

              </template>

              <!-- REQUEST SYSTEM -->
              <template v-if="filters?.requests_trainings">

                <!-- REQUEST BUTTON -->
                <button v-if="subItem?.id &&
                  !subItem.user_request &&
                  (
                    !subItem.self_registrable_trainings ||
                    subItem.self_registrable_trainings.length === 0
                  )
                  " class="btn btn-sm btn-primary" type="button" @click="$emit('request-training', subItem.id)">
                  <i class="uil-bell"></i>
                  {{ $t('general.request') }}
                </button>

                <!-- REQUESTED -->
                <button v-else-if="subItem.user_request &&
                  Number(subItem.user_request.training_status_id) === 1
                  " class="btn btn-sm btn-secondary" type="button" disabled>
                  <i class="fa fa-check"></i>
                  {{ $t('general.requested') }}
                </button>

                <!-- REJECTED -->
                <button v-else-if="subItem.user_request &&
                  Number(subItem.user_request.training_status_id) === 0
                  " class="btn btn-sm btn-danger" type="button" disabled>
                  {{ $t('general.reject_request') }}
                </button>

              </template>

            </template>

          </div>

          <!-- Meta -->
          <div class="card-meta">

            <span class="meta-badge">
              <i class="uil-book-open"></i>

              {{
                $t('education.section_count', {
                  number: subItem.training_content_count
                })
              }}
            </span>

            <span v-if="subItem.training_type?.name" class="meta-type">
              {{ subItem.training_type.name }}
            </span>

          </div>

          <!-- Description -->
          <p v-if="subItem.description" class="card-description">
            {{ subItem.description }}
          </p>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CatalogCardList",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    filters: {
      type: Object,
      default: () => ({})
    },
    getBottomTitle: {
      type: Function,
      default: () => () => ''
    },
    isDemoActive: {
      type: Function,
      default: () => false
    },
    formatPrice: {
      type: Function,
      default: () => () => ''
    }
  }
}
</script>

<style scoped>
.catalog-card-list {
  background: #fff;
}

.catalog-card-item {
  border-bottom: 1px solid #f0f0f0;
}

.catalog-card-item:last-child {
  border-bottom: none;
}

.card-inner {
  display: flex;
  gap: 20px;
  padding: 20px;
}

/* Image */
.card-image-wrapper {
  flex-shrink: 0;
  width: 200px;
}

.card-image {
  width: 100%;
  height: 140px;
  object-fit: cover;
  object-position: center;
  border-radius: 8px;
  background: #f6f6f6;
  cursor: pointer;
  transition: transform 0.2s ease;
  will-change: transform;
}

.card-image:hover {
  transform: scale(1.02);
}

/* Content */
.card-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.card-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #2d3748;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Actions */
.card-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  justify-content: flex-end;
  margin-left: auto;
}

.card-actions .btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: opacity 0.2s ease;
  white-space: nowrap;
}

.card-actions .btn i {
  font-size: 14px;
}

.price-tag {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  background: #f8fafc;
  color: #2d3748;
  font-size: 13px;
  font-weight: 600;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
}

/* Meta */
.card-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
}

.meta-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  background: #f1f5f9;
  color: #64748b;
  font-size: 12px;
  border-radius: 4px;
}

.meta-badge i {
  font-size: 14px;
}

.meta-type {
  font-size: 12px;
  color: #94a3b8;
}

/* Description */
.card-description {
  margin: 0;
  font-size: 13px;
  color: #64748b;
  line-height: 1.6;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Responsive - Tablet */
@media (max-width: 959px) {
  .catalog-card-list {
    background: transparent;
  }

  .catalog-card-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .catalog-card-item {
    background: #ffffff;
    border-bottom: none;
    border-radius: 14px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }

  .card-inner {
    gap: 16px;
    padding: 16px;
  }

  .card-image-wrapper {
    width: 160px;
  }

  .card-image {
    height: 120px;
    border-radius: 14px;
  }

  .card-image:hover {
    transform: none;
    box-shadow: none;
  }

  .card-title {
    font-size: 15px;
  }

  .card-actions .btn {
    padding: 5px 10px;
    font-size: 12px;
  }
}

/* Responsive - Mobile */
@media (max-width: 639px) {
  .catalog-card-list {
    background: transparent;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .catalog-card-item {
    background: #ffffff;
    border-radius: 14px;
    border-bottom: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }

  .catalog-card-item:active {
    transform: scale(0.99);
  }

  .card-inner {
    flex-direction: column;
    gap: 12px;
    padding: 16px;
  }

  .card-image-wrapper {
    width: 100%;
  }

  .card-image {
    height: 180px;
    width: 100%;
    border-radius: 14px;
    transition: none;
  }

  .card-image:hover {
    transform: none;
    box-shadow: none;
  }

  .card-image:active {
    opacity: 0.9;
  }

  .card-content {
    gap: 10px;
  }

  .card-title {
    font-size: 16px;
    -webkit-line-clamp: 3;
    line-height: 1.4;
  }

  .card-actions {
    gap: 8px;
    justify-content: flex-start;
  }

  .card-actions .btn {
    flex: 0 0 auto;
    justify-content: center;
    min-height: 44px;
    padding: 10px 16px;
    font-size: 14px;
    border-radius: 10px;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }

  .card-actions .btn:hover {
    transform: none;
    box-shadow: none;
  }

  .card-actions .btn:active {
    opacity: 0.85;
    transform: scale(0.98);
  }

  .price-tag {
    flex: 0 0 auto;
    min-height: 44px;
    padding: 10px 16px;
    font-size: 14px;
    font-weight: 600;
    border-radius: 10px;
    display: inline-flex;
    align-items: center;
  }

  .card-meta {
    gap: 8px;
  }

  .meta-badge {
    font-size: 12px;
    padding: 4px 10px;
    border-radius: 8px;
  }

  .meta-badge i {
    font-size: 14px;
  }

  .meta-type {
    font-size: 12px;
  }

  .card-description {
    font-size: 14px;
    -webkit-line-clamp: 3;
    line-height: 1.5;
  }
}

/* Responsive - Small Mobile */
@media (max-width: 479px) {
  .catalog-card-list {
    gap: 12px;
  }

  .card-inner {
    padding: 12px;
  }

  .card-image {
    height: 160px;
  }

  .card-actions {
    flex-wrap: wrap;
  }

  .card-actions .btn {
    padding: 10px 14px;
    font-size: 13px;
  }
}

@media (max-width: 639px) {
  .catalog-card-item {
    overflow: hidden;
    border-radius: 12px;
  }

  .card-inner {
    gap: 12px;
    padding: 12px;
  }

  .card-image-wrapper {
    width: 100%;
    aspect-ratio: 16 / 9;
  }

  .card-image {
    height: 100%;
    min-height: 0;
    border-radius: 10px;
  }

  .card-content {
    gap: 12px;
  }

  .card-title {
    min-height: calc(16px * 1.4 * 2);
    font-size: 16px;
    line-height: 1.4;
    -webkit-line-clamp: 2;
  }

  .card-actions {
    width: 100%;
    margin-left: 0;
    justify-content: flex-start;
  }

  .card-actions .btn,
  .price-tag {
    min-height: 48px;
    box-sizing: border-box;
  }

  .card-meta {
    min-height: 24px;
  }
}
</style>
